<template>
  <div>
    <h3>Forgot Password</h3>
    <div v-if="loadStatus === 'error'">
      <p>{{passwordError}}</p>
    </div>
    <div>
      <div class="row" v-if="canSubmit">
        <div class="six columns">
          <label for="reset-email">Email</label>
          <input
            class="u-full-width"
            id="reset-email"
            type="text"
            placeholder="email"
            v-model="email"
          >
        </div>
        <div class="twelve columns">
          <input
            class="button"
            value="Reset Password"
            @click="reset"
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      loadStatus: '',
      passwordError: '',
      email: '',
      canSubmit: true
    }
  },
  methods: {
    reset () {
      this.loadStatus = 'loading'
      this.$http.post(process.env.API_URL + '/forgotpassword.php', {
        email: this.email
      }).then((res) => {
        if (res.body.status === 'success') {
          this.loadStatus = 'success'
          this.canSubmit = false
        }
        this.loadStatus = 'error'
        this.passwordError = res.body.data
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// ForgotPassword.vue?6905d22d